export const USERNAME_HEADER = "Choose a username";

export const USERNAME_SUBHEADER =
  "A username is needed to buy and sell wearables.";
